export default {
  name: 'ProductTabIngredients',
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  created() {},
  mounted() {},
  watch: {},
  computed: {},
  methods: {}
};
